export default "__VITE_ASSET__DIPrHfI1__"